import React, { ReactNode, useState } from 'react'
import { Images } from '@verzekeringapp-mono/shared/src/assets'
import HelpModal from '~/screens/authentication/register/components/help_modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface IProps {
  children: ReactNode
  showHelpButton?: boolean
  helpButtonText?: string
}

const LoginScreenWrapper: React.FC<IProps> = props => {
  const [isHelpModalOpen, setHelpModalOpen] = useState(false)

  return (
    <div className='login-body-container'>
      <div className='login-left-container'>
        <img
          src={Images.Background}
          className='w-full h-full object-cover'
          alt=''
        />
      </div>

      <div className='login-right-container px-8'>
        <div className='overflow-y-auto'>
          <div className='w-2/3 py-10 mx-auto'>
            <button
              className='absolute top-8 right-8'
              onClick={() => setHelpModalOpen(true)}
            >
              <div className='flex items-center'>
                <h2 className='light mr-2'>Help</h2>

                <FontAwesomeIcon
                  icon='question-circle'
                  size='xl'
                  className='text-icon-secondary'
                />
              </div>
            </button>

            {props.children}

            {props.showHelpButton
              ? (
                <button
                  className='light mt-4'
                  onClick={() => setHelpModalOpen(true)}
                >
                  {props?.helpButtonText ?? ''}
                </button>
              )
              : null}
          </div>
        </div>
      </div>

      {isHelpModalOpen && <HelpModal onClose={() => setHelpModalOpen(false)} />}
    </div>
  )
}

export default LoginScreenWrapper
